import { Component, effect, inject, input, NgZone, output, TemplateRef, viewChild } from '@angular/core';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { filter, map, pairwise, throttleTime } from 'rxjs/operators';
import { NgTemplateOutlet } from '@angular/common';

@Component({
	selector: 'app-incremental-list',
	templateUrl: './incremental-list.component.html',
	styleUrls: ['./incremental-list.component.scss'],
	imports: [CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NgTemplateOutlet],
})
export class IncrementalListComponent<E> {
	private readonly ngZone = inject(NgZone);

	readonly elementen = input.required<E[]>();
	readonly itemSize = input.required<number>();
	readonly loading = input.required<boolean>();
	readonly itemTemplate = input.required<TemplateRef<{ $implicit: E }>>();
	readonly emptyTemplate = input.required<TemplateRef<{}>>();
	readonly loaderTemplate = input<TemplateRef<{}>>();
	readonly exportMode = input<boolean>(false); // Schakel export modus in/uit

	readonly nextPage = output<number>();

	readonly scroller = viewChild<CdkVirtualScrollViewport>('scroller');

	constructor() {
		effect((onCleanup) => {
			const viewport = this.scroller();
			if (!viewport || this.exportMode()) return;

			const subscription = viewport
				.elementScrolled()
				.pipe(
					map(() => viewport.measureScrollOffset('bottom')),
					pairwise(),
					filter(([y1, y2]) => y2 < y1 && y2 < 140),
					throttleTime(200)
				)
				.subscribe(() => {
					this.ngZone.run(() => this.nextPage.emit(this.elementen().length));
				});

			onCleanup(() => subscription.unsubscribe());
		});
	}
}
